var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowndiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.789,
    height: 4.727,
    viewBox: "1132.968 146.637 7.789 4.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1136.56 151.238-3.466-3.466a.428.428 0 0 1 0-.606l.404-.404a.428.428 0 0 1 .605 0l2.76 2.747 2.76-2.747a.428.428 0 0 1 .605 0l.404.405a.428.428 0 0 1 0 .605l-3.466 3.466a.428.428 0 0 1-.606 0Z",
    fillRule: "evenodd",
    "data-name": "Icon awesome-chevron-left"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowndiscountIcon);
export default __webpack_public_path__ + "static/media/downdiscountIcon.04f48079780dc5a0e83b9146f2dccbb8.svg";
export { ForwardRef as ReactComponent };